import apiUrl from "./apiUrl";

export default function fetchApi(endpoint: string) {
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  return {
    get: async (url: string) => {
      const response = await fetch(`${apiUrl}/api/${endpoint}${url}`, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "An error occurred when fetching data"
        );
      }

      return response.json();
    },

    post: async (url: string, body: any) => {
      const response = await fetch(`${apiUrl}/api/${endpoint}`, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "An error occurred when posting data"
        );
      }

      return response.json();
    },

    put: async (url: string, body: any) => {
      const response = await fetch(`${apiUrl}/api/${endpoint}${url}`, {
        method: "PUT",
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "An error occurred when updating data"
        );
      }

      return response.json();
    },

    delete: async (url: string) => {
      const response = await fetch(`${apiUrl}/api/${endpoint}${url}`, {
        method: "DELETE",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "An error occurred while deleting data"
        );
      }

      return { status: response.status, message: "Deleted successfully" };
    },
  };
}
